import { useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";
import Section from "../components/Section";
import gen2logo from "../images/gen2logo.png";
import { HowItWork } from "../pages/NFTgen2Page";
import BoldHeading from "./BoldHeading";

const HowSection = () => {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Section pb="0">
      <Box className="d-flex justify-center flex-wrap" mb={md ? 5 : 3}>
        <img src={gen2logo} alt="" height="124px" />
        <Box pr={1}>
          <BoldHeading lineHeight={1} mt="-4px">
            How
          </BoldHeading>
          <Typography variant="h5" lineHeight={1} mt={1} align="right">
            it works
          </Typography>
        </Box>
        <BoldHeading lineHeight={1} fontWeight="normal" mt="-4px">
          ?
        </BoldHeading>
      </Box>
      <HowItWork white={true} />
    </Section>
  );
};

export default HowSection;
